import { EVENTS } from '../actionTypes';

const initialState = {
  content: [],
  eventReceipt: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case EVENTS.SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    case EVENTS.RECEIPT_SUCCESS:
      return {
        ...state,
        eventReceipt: action.payload,
      };
    default:
      return state;
  }
};
